class ManageHorizontalSlide {
    constructor(swiper) {
        this.sections         = document.querySelectorAll('.section');
        this.mySwiperVertical = document.querySelector('main > .swiper-container').swiper;
        this.body             = document.body;
        this.navbarBrand      = document.querySelector('.navbar-brand');
        this.header           = document.getElementById('header');
        this.navbarStart      = document.querySelector('.navbar-start');
        this.swiper           = swiper;

        this.chooseMyCableSection = 3;
        this.slideAnimationTime   = 500;

        this.doAHozitontalSlide();
    }

    doAHozitontalSlide() {
        for (let i = 0; i < this.sections.length; i++) {

            // for every sections that contain the buttons
            if (this.sections[i].querySelector('.container-btn')) {

                if (i !== this.chooseMyCableSection) {
                    let containerBtn               = this.sections[i].querySelector('.container-btn');
                    let buttonsToSlideHorizontally = containerBtn.querySelectorAll('.second-container');
                    let slideBackNext              = this.sections[i].querySelectorAll('.slide-back-next');
                    let slides                     = this.sections[i].querySelectorAll('.main-content');

                    // manage the hortizontal slide on each buttons on each sections on the homepage
                    for (let j = 0; j < buttonsToSlideHorizontally.length; j++) {
                        let slideToGoTo = j + 1;

                        buttonsToSlideHorizontally[j].addEventListener('click', (e) => {

                            // BUTTON ON THE HOMEPAGE IN EACH SECTION
                            // the button with the class do-not-show-arrow is the only one which redirects on another website
                            // this is why we don't want it to scroll
                            if (!buttonsToSlideHorizontally[j].classList.contains('do-not-show-arrow')) {
                                e.preventDefault();

                                // the homepage slide will move no matter which buttons got clicked on
                                slides[0].classList.add('active');
                                slides[slideToGoTo].classList.add('active');
                                this.body.classList.add('slider-is-active');
                                this.navbarBrand.classList.add('active-slide');
                                this.header.classList.add('set-bg');
                                this.navbarStart.classList.remove('is-clicked');

                                if (!this.header.classList.add(this.swiper.slides[this.swiper.activeIndex].id)) {
                                    this.header.classList.add(this.swiper.slides[this.swiper.activeIndex].id);
                                }

                                // prevent the user to scroll vertically when the horizontal slider is active
                                this.mySwiperVertical.allowSlideNext = false;
                                this.mySwiperVertical.allowSlidePrev = false;

                                // allow the user to scroll through the current section
                                this.mySwiperVertical.mousewheel.disable();
                                this.mySwiperVertical.detachEvents();
                            }
                        });
                    }


                    for (let j = 0; j < slideBackNext.length; j++) {
                        let currentSlide = j + 1;
                        let nextSlide    = j + 2;
                        // NEXT BUTTON
                        // manage the horizontal slide when clicking on a slide next button
                        if (slideBackNext[j].querySelector('.next')) {

                            let nextButton = slideBackNext[j].querySelector('.next');

                            nextButton.addEventListener('click', () => {
                                slides[currentSlide].classList.add('inactive');
                                slides[currentSlide].classList.remove('active');
                                slides[nextSlide].classList.add('active');
                            });
                        }

                        // BACK BUTTON
                        // manage the horizontal slide when clicking on a slide back button
                        if (slideBackNext[j].querySelector('.back')) {
                            let lastSlide                   = slideBackNext.length - 1;
                            let secondSlideOfTheLastSection = slideBackNext.length - 2;
                            let backButton                  = slideBackNext[j].querySelector('.back');

                            // this will prevent to see every previous slides during the animation
                            // when u press back button of the last slide
                            if (j === lastSlide) {
                                backButton.addEventListener('click', () => {
                                    for (let k = 1; k < slides.length - 1; k++) {
                                        slides[k].classList.add('hide');
                                        setTimeout(() => {
                                            slides[k].classList.remove('hide');
                                        }, this.slideAnimationTime);
                                    }
                                });
                            }

                            // the case when we are on the last section (recup and manage)
                            // and we click on the back btn of the third slide
                            if (j === secondSlideOfTheLastSection && slideBackNext.length === 3) {
                                let keepDocumentsSlide = 1;
                                backButton.addEventListener('click', () => {
                                    slides[keepDocumentsSlide].classList.add('hide');
                                    setTimeout(() => {
                                        slides[keepDocumentsSlide].classList.remove('hide');
                                    }, this.slideAnimationTime);
                                });
                            }

                            backButton.addEventListener('click', () => {

                                for (let k = 0; k < slides.length; k++) {
                                    slides[k].classList.remove('active');
                                    slides[k].classList.remove('inactive');
                                }

                                this.header.classList.add('slide-out');

                                // close the open menu if it is open
                                this.navbarStart.classList.remove('is-clicked-while-slider-is-active');

                                setTimeout(() => {
                                    // for the item menu color
                                    this.body.classList.remove('slider-is-active');
                                    // for the rpc logo color
                                    this.navbarBrand.classList.remove('active-slide');
                                    // remove the header background
                                    this.header.classList.remove('slide-out');
                                    this.header.classList.remove('set-bg');
                                }, 400);

                                // allow the user to scroll between each sections
                                this.mySwiperVertical.allowSlideNext = true;
                                this.mySwiperVertical.allowSlidePrev = true;

                                // prevent the user to scroll through the current section
                                this.mySwiperVertical.mousewheel.enable();
                                this.mySwiperVertical.attachEvents();
                            });
                        }
                    }
                }
            }
        }
    }
}